import { render } from "./DiaDiemChamCong.vue?vue&type=template&id=271ae896&scoped=true"
import script from "./DiaDiemChamCong.vue?vue&type=script&lang=js"
export * from "./DiaDiemChamCong.vue?vue&type=script&lang=js"

import "./DiaDiemChamCong.vue?vue&type=style&index=0&id=271ae896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271ae896"]])

export default __exports__